var React = require('react');

function SchedulingIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#131416","fillRule":"evenodd","d":"M6 1h2v2h8V1h2v2h4v8.101A6.977 6.977 0 0 1 24 16a6.977 6.977 0 0 1-2 4.899V21h-.101A6.977 6.977 0 0 1 17 23a6.977 6.977 0 0 1-4.899-2H2V3h4V1Zm4.674 18A6.973 6.973 0 0 1 10 16a6.98 6.98 0 0 1 2.101-5H11V9h2v1.255a6.972 6.972 0 0 1 2-.965V9h2c1.074 0 2.09.242 3 .674V5H4v14h6.674ZM9 9v2H7V9h2Zm0 6v-2H7v2h2Zm3 1a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm7.843 1.23-1.08 1.44L16 16.54V12h2v3.64l1.843 1.59Z","clipRule":"evenodd"}));
}

SchedulingIconInline.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = SchedulingIconInline;

SchedulingIconInline.default = SchedulingIconInline;
